import { PlatformApi } from '../../configs/appRoute';
import { AxiosAuth } from '../../core';
import { ApiResponse } from '../../models';
import { VendorCallLogPagedResponseModel } from '../../models/api/Call';
import { AppConstants } from '../../configs';
import { ApiSchemaFilter } from '../../models/api/filter';

type Props = {
  pageSize?: number;
  pageNo?: number;
  searchText?: string;
  setLoaderProgress?: any;
  filterData: ApiSchemaFilter;
};

export function useFunctionalityVendorCallLog(props: Props) {
  const { pageSize, pageNo, searchText, filterData } = props;
  const pagedVendorCallLogsUrl = PlatformApi.Call.FilteredGetVendorCalls(
    pageSize,
    pageNo,
    searchText
  );

  const LoadVendorCallLog = async () => {
    const res = await AxiosAuth.post<ApiResponse<VendorCallLogPagedResponseModel>>(
      pagedVendorCallLogsUrl,
      filterData
    );
    if ((res.status = AppConstants.Api.StatusOK)) {
      return Promise.resolve(res.data);
    }
  };
  return {
    LoadVendorCallLog,
  };
}

